import ScalarIconCaretRight_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCaretRight.vue.script.js";
//#region src/components/ScalarIconCaretRight.vue
var ScalarIconCaretRight_default = ScalarIconCaretRight_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCaretRight_default as default };

//# sourceMappingURL=ScalarIconCaretRight.js.map